module.exports = __webpack_public_path__ + "img/icon-copy.9a2460c4.svg";